import React, { useState } from "react";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import { PIN_TITLE, PIN_WRONG } from "@/lib/helpers";
import { Delete } from "lucide-react";

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "", "0", "back"];

export default function PinGate() {
  const { markUnlocked, family } = useApp();
  const [pin, setPin] = useState("");
  const [err, setErr] = useState("");
  const [checking, setChecking] = useState(false);

  const tap = async (k) => {
    if (checking) return;
    setErr("");
    if (k === "back") {
      setPin((p) => p.slice(0, -1));
      return;
    }
    if (k === "") return;
    const next = (pin + k).slice(0, 4);
    setPin(next);
    if (next.length === 4) {
      setChecking(true);
      try {
        const res = await api.verifyPin(next);
        if (res.ok) {
          markUnlocked();
        } else {
          setErr(PIN_WRONG);
          setTimeout(() => setPin(""), 400);
        }
      } catch (e) {
        setErr("Something broke. Try again.");
        setTimeout(() => setPin(""), 400);
      } finally {
        setChecking(false);
      }
    }
  };

  return (
    <div className="wc-shell flex flex-col items-center justify-center bg-[#0A3D62] text-[#FAF8F3] px-8 py-10">
      <div className="text-6xl mb-4">🎣</div>
      <div className="font-display text-xl mb-2 opacity-80">{family?.comp_name || "Glenlyon Fishing Challenge"}</div>
      <h1 className="font-display text-3xl font-black mb-8">{PIN_TITLE}</h1>

      <div className="flex gap-3 mb-2" data-testid="pin-dots">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className={`w-4 h-4 rounded-full transition-all ${
              pin.length > i ? "bg-[#E8A838] scale-110" : "bg-[#FAF8F3]/20"
            }`}
          />
        ))}
      </div>
      <div className="h-6 mt-2 text-[#E8A838] font-semibold text-sm" data-testid="pin-error">
        {err}
      </div>

      <div className="grid grid-cols-3 gap-4 mt-4 w-full max-w-xs">
        {KEYS.map((k, i) =>
          k === "" ? (
            <div key={i} />
          ) : (
            <button
              key={i}
              data-testid={`pin-key-${k}`}
              onClick={() => tap(k)}
              className="h-16 rounded-2xl bg-white/10 hover:bg-white/15 active:bg-white/20 active:scale-95 transition font-display text-3xl font-black text-[#FAF8F3] flex items-center justify-center border border-white/10"
            >
              {k === "back" ? <Delete className="w-6 h-6" strokeWidth={2.5} /> : k}
            </button>
          ),
        )}
      </div>
    </div>
  );
}
